var React = require( 'react' );
var createReactClass = require('create-react-class');
var ReactRedux = require("react-redux");
var PropTypes = require('prop-types');
var bindActionCreators = require("redux").bindActionCreators;
var Modal = require('./modal.jsx');
var modalActions = require('../../../modules/modals/actions/modal');
var profileActions = require('../../../modules/profile/actions/profile');
var clinicalTrialsMetaActions = require('../../../modules/meta/actions/clinical-trials');
var postalCodeUtils = require('../../../modules/profile/postalCodeUtils');

var InterestedInClinicalTrialsModal = createReactClass({

    componentWillUnmount: function(){
        this.props.clearPostalCodeError();
    },

    onClose: function() {
        this.props.hideModal();
    },

    handleInterestedInClinicalTirals: function(e){
        var postalCode = this.refs.postalCode && this.refs.postalCode.value.trim();
        var trackingLabel = e.currentTarget.innerText;

        if(this.refs.postalCode) {
            postalCodeUtils.validate(postalCode)
                .then(function(result) {
                    if (result === true) {
                        this.doInterestedInClinicalTirals(postalCode, trackingLabel);
                    } else {
                        this.props.setPostalCodeError(result);
                    }
                }.bind(this));
        } else {
            this.doInterestedInClinicalTirals(null, trackingLabel);
        }
    },

    doInterestedInClinicalTirals: function(postalCode, trackingLabel){
        if(this.props.token){
            this.props.interestedInClinicalTrials(postalCode, this.props.token);
        }else{
            this.context.router.push('/register');
        }

        this.props.recordClinicalTrialsClick('Click', trackingLabel);
    },

    render: function() {
        var id = this.props.modal.props.id || 'interestedInClinicalTrials';

        return (
            <Modal onClose={this.onClose} id={id}>
                <div className="text">
                    <h3>Find Out About Clinical Trials</h3>
                    <p>By letting us know you're interested, we'll match you with clinical trials that are currently recruiting GI patients. You may be compensated for your time if you are successfully enrolled.</p>
                    {this.props.token && !this.props.profile.data.postalCode && (
                        <div className="postalCode-field-wrap">
                            <div className="postalCode-input-field input-field">
                                <label htmlFor="postalCode" className="heading">ZIP Code</label>
                                <input type="text" name="postalCode" id="postalCode" ref="postalCode" placeholder="ZIP Code" required />
                                <div className="tip">
                                    <span className="ion-ios-information-outline"></span>
                                    <p>Your location helps us find relevant clinical trials near you</p>
                                </div>
                            </div>
                            {Object.keys(this.props.profile.postalCodeError).length > 0 && (
                                <p className="error">{this.props.profile.postalCodeError}</p>
                            )}
                        </div>
                    )}

                    <div className="actions">
                        <button className="button primary" onClick={this.handleInterestedInClinicalTirals}>Yes I'm interested, sign me up!</button>
                        <button className="button show-for-small-only" onClick={this.onClose}>No Thanks</button>
                    </div>
                </div>
            </Modal>
        );
    }

});

InterestedInClinicalTrialsModal.contextTypes = {
    router: PropTypes.object.isRequired
};

var mapStateToProps = function(state){
    return {
        token: state.auth.token,
        profile: state.profile
    };
}

var mapDispatchToProps = function(dispatch) {
    return bindActionCreators(Object.assign({}, modalActions, profileActions, clinicalTrialsMetaActions), dispatch);
}

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(InterestedInClinicalTrialsModal);



// WEBPACK FOOTER //
// ./src/common/routes/components/modals/interestedInClinicalTrialsModal.jsx